<template> 
    <span>
        <div v-show="!readonly">
            <InputFile v-bind:is-error="isError" v-bind:title="label" v-bind:onload="fileOnLoad" ref="inputFile" v-model="fileModel"/>  
        </div>
        <div v-for="(item, index) in value" :key="index">
            <!-- <a @click="download(item)" :href="item.data" :download="item.filename">{{item.filename}}</a> -->
            <a class="btn" @click="download(item)" >{{item.filename}}</a>
            <a class="btn" @click="deleteFileItems(index)" title="点击删除" v-show="!readonly">X</a>
        </div>
    </span>
</template>
<script>
    //https://github.com/yorkbc2/vue-impot-xlsx
    import store from '@/store';
	import InputFile from "@/components/common/file/InputFile.vue"
    import {calculateFileSize, readBase64DataFromFile} from "@/components/common/file/fileModule.js"
    import download from '@/components/common/file/download.js'//https://github.com/rndme/download#simple-global-download-function-via-script-include
    export default {
        components: {
            InputFile
        },
        data(){
            return {
				label: "",
				labels: {
					startLabel: "把文件拖到这里，或者点击选择。",
					successLabel: '文件是 - "?"',
					sizeError: "最大允许一个?MB文件，选择另一个文件。",
					extensionError: '只允许的文件类型: "?", 选择另一个文件。'
				},
                isError: false,
                fileModel: null, 
            }
        },
        props: {
            maxFileSizeMB: null,
            acceptFileTypes: null,
            value: null,
            downloadPath: null,
            maxFileSize: null,
            readonly: null,
        },
         watch: {
            fileModel: {
                handler(newValue, oldValue) {
                    if(newValue == null){
                        this.label = this.labels.startLabel;  
                    }
                },
                deep: true
            }
        },
        mounted(){
            this.label = this.labels.startLabel;
        },
        created(){        
        },
        activated() {			
			this.label = this.labels.startLabel;
        },
        methods: {			
            deleteFileItems(index){
                this.value.splice(index,1);
            },
            download(item){
                var that = this;
                 let splittedName = item.filename.split('.'),
                    splittedNameLastElement = splittedName[splittedName.length - 1];
                    console.log(splittedNameLastElement);
                if(item.id){
                    var access_token = store.user.get_access_token();
                    if(access_token == null){
                        //token 为空，重新登陆
                        store.user.relogin();
                    } 
                    var download_url = that.downloadPath + item.id;

                    var x=new XMLHttpRequest();
                    x.open( "GET", download_url , true);
                    x.setRequestHeader("Authorization", 'Bearer ' + access_token );
                    x.responseType="blob";
                    x.onload= function(e){download(e.target.response, item.filename, "application/"+splittedNameLastElement);};
                    x.send();
                }else{
                    download(item.data, item.filename, "application/"+splittedNameLastElement);
                }
            },
            /**
            * @param {Event} event Событие, которое передает onChange
            */
            fileOnLoad(event) {
                var that = this; 
                //check maxFile
                if(that.maxFileSize && that.value != null){
                    if(that.maxFileSize <= that.value.length){
                        this.label = "最多只能上传" + that.maxFileSize + "个文件";
                        return false; 
                    }
                }                
                //that.$emit("input", null);
                //that.$emit("change", null); 
                this.label = this.labels.startLabel;                
                // Берем файл, который загрузил клиент
                let uploadedFile = event.target.files[0];
                // Размер файла в МБ
                let size = calculateFileSize(uploadedFile.size);
                if (size > (this.maxFileSizeMB?this.maxFileSizeMB:10)) {
                    this.toggleIsError(true)
                    this.label = this.labels.sizeError.replace('?', this.maxFileSizeMB?this.maxFileSizeMB:10);
                    //that.$emit("input", that.value);
                    //that.$emit("change", that.value); 
                    return false;
                }
                // Розрываем название файла, чтобы получить его расширение
                let splittedName = uploadedFile.name.split('.'),
                    // Получаем последний элемент массива
                    splittedNameLastElement = splittedName[splittedName.length - 1];
                // Проверяем расширение файла
                if(that.acceptFileTypes){
                    var acceptFileTypesArr = that.acceptFileTypes.split(",");
                    var mapped = false;
                    for(var i=0; i< acceptFileTypesArr.length; i++){
                        if (splittedNameLastElement.toLowerCase() == acceptFileTypesArr[i].trim().toLowerCase())
                            mapped = true;
                    }
                    if(mapped == false){
                        this.label = this.labels.extensionError.replace('?', that.acceptFileTypes);
                        return false;
                    }
                }
                /* if (splittedNameLastElement !== 'xls' && splittedNameLastElement !== 'xlsx') {
                    this.toggleIsError(true)
                    // Ошибка об неправильном расширении файла
                    this.label = this.labels.extensionError
                                        .replace('?', '.' + splittedNameLastElement.toLowerCase())
                    return false;
                }  */
                this.toggleIsError(false)
                // Оповещение об успешной валидации файла
                this.label = this.labels.successLabel.replace("?", uploadedFile.name);
                // Прочитка файла с помощью функции с модуля fileModule
                readBase64DataFromFile(uploadedFile).then((response /*:object*/) => {
                  console.log(response);
                  that.value.push({
                      filename: uploadedFile.name,
                      id: null,
                      data: response
                  });
                  setTimeout(()=>{that.fileModel = 1;}, 0);
                  setTimeout(()=>{that.fileModel = null;}, 0);                                  
                });
                that.$emit("input", that.value);
                that.$emit("change", that.value); 
            },
			// Изменяет значение свойства isError на указаное
			/**
			* @param {boolean} isError
			*/
			toggleIsError(isError) {
			    this.isError = isError || false;
			} 
        }
    }
</script>
<style>


</style>



// WEBPACK FOOTER //
// src/components/common/selector/file/selectorFiles.vue